/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Helmet } from "react-helmet";
import Canonical from "../../../../components/common/layout/Canonical";
import { useTranslation } from "react-i18next";
import CorporateBanner from "../../../../components/common/form/CorporateBanner";
import { CategoryBg } from "../../../../components/common/svg/AllSvg";
import { useEffect, useState } from "react";
import { useSitemap } from "../../../../shared/hooks/use-sitemap";
import { useSelector } from "react-redux";
import useAxios from "../../../../shared/hooks/use-axios";
import { url } from "../../../../shared/utils/url";
import PaginationComponent from "../../../../components/common/form/PaginationComponent";
import Error from "../../../../components/common/form/Error";
import moment from "moment";
import { Link } from "react-router-dom";
import EmptyList from "../../../../components/common/form/EmptyList";
// import Lightbox from "react-awesome-lightbox";
import Lightbox from 'react-image-lightbox';

const PublicConsultation = () => {
    const { t } = useTranslation('common');
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [selectIdx, setSelectIdx] = useState<any>(null);
    const [idx, setIdx] = useState<any>(0);
    const [data, setData] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const [page, setPage] = useState<number>(1);
    const [total, setTotal] = useState<number>(0);
    const [size, setSize] = useState<any>({ label: `10 ${t("recruitment.home.per_page")}`, value: "10" });
    let totalPages: number = Math.ceil(total / +size?.value);
    const loaderData: any[] = [1, 2, 3, 4, 5]
    useSitemap();

    const getPublicConsultation = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url.public_consultation}?page=${page}&size=${+size?.value}`);

            if (res && res.status === 200) {
                if (res?.data?.results?.length > 0) {
                    // let arr: any[] = []
                    // res?.data?.results.forEach((el: any) => {
                    //     arr.push({
                    //         ...el,
                    //         imgs: el?.gallery?.gallery_images?.map((img: any) => ({ url: img?.image?.url, title: el?.gallery?.name }))
                    //     })
                    // });
                    setData(res?.data?.results)
                } else {
                    setData([])
                }
                setTotal(res?.data?.count)
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            setIsError(true)
            console.error("error while fetching public consultation", error);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        !!lang && getPublicConsultation();
    }, [lang, size, page])

    const isValidDate = (dateString: any) => {
        const date: any = new Date(dateString);
        const valid: boolean = !isNaN(date.getTime())
        if (valid) {
            return moment(dateString).format('DD MMM YYYY')
        } else {
            return dateString
        }
    }

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.public_consultation.title")}</title>
                <meta name="description" content={t("seo_friendly.public_consultation.desc")} />
            </Helmet>

            <div className='bg-white dark:bg-bgDarkDull'>
                <CorporateBanner title={t("corporate.content_pages.public_consultation.title")} root1={t("corporate.content_pages.photo_gallery.home")} root2={t("corporate.content_pages.illustrative_designs.subtitle")} root3={t("corporate.content_pages.public_consultation.title")} />
                <div id="home" className="container corporate-pages">
                    <div className='corporate-content-sec'>
                        {loading ?
                            <div className="w-full grid grid-cols-1 xlsm:grid-cols-2 mms:grid-cols-1 msm:grid-cols-2 xl:grid-cols-3 gap-[15px] xlx:gap-[20px]">
                                {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                                    <div key={index} className="border border-[#EAEAEA] w-full flex flex-col p-[10px] xlx:p-[14px] animate-pulse">
                                        <div className="flex items-center justify-center w-full h-[170px] bg-gray-300 rounded-sm dark:bg-gray-700">
                                            <svg className="w-[50px] h-[50px] text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                                                <path className="w-full" d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
                                            </svg>
                                        </div>
                                        <div className="flex flex-col gap-[10px] xlx:gap-[14px] pt-[10px] xlx:pt-[14px]">
                                            <div className="w-[90px] h-[25px] rounded-full bg-gray-300 dark:bg-gray-700"></div>

                                            <div className="flex flex-col gap-[8px] w-full">
                                                <div className="bg-gray-200 dark:dark:bg-gray-700 rounded-full h-[12px] w-full"></div>
                                                <div className="bg-gray-200 dark:dark:bg-gray-700 rounded-full h-[12px] w-[50%]"></div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            :
                            <>
                                {isError ?
                                    <Error />
                                    : <>
                                        {data?.length > 0 ? <>
                                            <div className="w-full grid grid-cols-1 xlsm:grid-cols-2 mms:grid-cols-1 msm:grid-cols-2 xl:grid-cols-3 gap-[15px] xlx:gap-[20px]">
                                                {Array.isArray(data) && data?.map((item: any, index: number) => (
                                                    <div key={index} className="border border-[#EAEAEA] dark:border-gray-700 hover:border-transparent dark:hover:border-transparent hover:bg-[#F8F8F8] hover:dark:bg-gray-800 focus:border-transparent dark:focus:border-transparent focus:bg-[#F8F8F8] focus:dark:bg-gray-800 w-full flex flex-col p-[10px] xlx:p-[14px]">
                                                        <button className="w-full h-[170px] bg-none border-none hover:shadow-md focus:shadow-md" onClick={() => setSelectIdx(index)}>
                                                            <img src={item?.gallery?.gallery_images?.[0]?.image?.url} alt={item?.imgs?.[0]?.title} className="w-full h-[170px]" />
                                                        </button>
                                                        <div className="flex flex-col gap-[10px] xlx:gap-[14px] pt-[10px] xlx:pt-[14px]">
                                                            <div className="flex items-center gap-[10px]">
                                                                <div className="flex items-center justify-center px-[13px] h-[25px] rounded-[15px] bg-primary bg-opacity-[0.1] text-primary text-[0.813rem] font-semibold"> {isValidDate(item?.date)}</div>
                                                            </div>

                                                            <Link className="text-primaryText dark:text-white focus:underline hover:underline font-bold line-clamp-2 text-lg" to={item?.consultation_pdf?.file} target="_blank">
                                                                {item?.description}
                                                            </Link>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="flex items-center justify-center w-full mt-[10px]">
                                                <PaginationComponent
                                                    page={page}
                                                    total={totalPages}
                                                    setPage={setPage}
                                                />
                                            </div>
                                            {(!!selectIdx || selectIdx === 0) &&
                                                // <Lightbox
                                                //     onClose={() => setSelectIdx(null)}
                                                //     images={data?.[selectIdx]?.imgs}
                                                // />
                                                <Lightbox
                                                    imageTitle={data?.[selectIdx]?.gallery?.name}
                                                    mainSrc={data?.[selectIdx]?.gallery?.gallery_images?.[idx]?.image?.url}
                                                    nextSrc={data?.[selectIdx]?.gallery?.gallery_images?.[(idx + 1) % data?.[selectIdx]?.gallery?.gallery_images.length]?.image?.url}
                                                    prevSrc={data?.[selectIdx]?.gallery?.gallery_images?.[(idx + data?.[selectIdx]?.gallery?.gallery_images?.length - 1) % data?.[selectIdx]?.gallery?.gallery_images?.length]?.image?.url}
                                                    onCloseRequest={() => setSelectIdx(null)}
                                                    onMovePrevRequest={() => setIdx((idx + data?.[selectIdx]?.gallery?.gallery_images.length - 1) % data?.[selectIdx]?.gallery?.gallery_images?.length)}
                                                    onMoveNextRequest={() => setIdx((idx + 1) % data?.[selectIdx]?.gallery?.gallery_images?.length)}
                                                />
                                            }
                                        </> :
                                            <EmptyList />
                                        }
                                    </>}
                            </>}
                    </div>

                    <div className="menu-sec">
                        <div className="menu-title">
                            <div className="bg">
                                <CategoryBg />
                            </div>

                            <h5>{t("corporate.content_pages.project_menu.rehabilitation_resettlement")}</h5>
                        </div>
                        <a className="inactive" href="/corporate/pages/flgrc-slgrc">{t("corporate.content_pages.project_menu.flgrc_slgrc")}</a>
                        <a className="active" href="/corporate/pages/public-consultation"> <svg xmlns="http://www.w3.org/2000/svg" width="5" height="14" viewBox="0 0 5 14" fill="none">
                            <path d="M2.354 2.25488L2.354 11.4967" stroke-width="4" stroke-linecap="round" />
                        </svg> {t("corporate.content_pages.project_menu.public_consultation")}</a>
                        <a className="inactive" href="/corporate/pages/final-bses">{t("corporate.content_pages.project_menu.final_bses")}</a>
                        <a className="inactive" href="/corporate/pages/lottery-result">{t("corporate.content_pages.project_menu.lottery_result")}</a>
                        <a className="inactive" href="/corporate/pages/policy-list">{t("corporate.content_pages.project_menu.policy_list")}</a>
                        <a className="inactive" href="/corporate/pages/in-situ-rr-office-address">{t("corporate.content_pages.project_menu.in_situ_rr_office_address")}</a>
                        <a className="inactive" href="/corporate/pages/bses-survey-maps">{t("corporate.content_pages.project_menu.bses_survey_maps")}</a>
                        <a className="inactive" href="/corporate/pages/building-wise-allotment-list">{t("corporate.content_pages.project_menu.building_wise_allotment_list")}</a>
                        <a className="inactive" href="/corporate/pages/rehabilitation-building-occupation">{t("corporate.content_pages.project_menu.rehabilitation_building_occupation")}</a>
                        <a className="inactive" href="/corporate/pages/public-notices"> {t("corporate.content_pages.project_menu.public_notices")}</a></div>
                </div>
            </div>
        </>
    );
};

export default PublicConsultation;